import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftOperationInternationalProps } from './props';
import { SarlaftOperationInternational } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftOperationInternational = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftOperationInternationalProps) => {
    const onSubmit = (data: SarlaftOperationInternational) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'foreignCurrencyTransactions',
            data?.foreignCurrencyTransactions || ''
        );
        formik?.setFieldValue(
            'whichCurrencyTransactions',
            data?.whichCurrencyTransactions || ''
        );
        formik?.setFieldValue('otherOperations', data?.otherOperations || '');
        formik?.setFieldValue(
            'financialProductsAbroad',
            data?.financialProductsAbroad || ''
        );
        formik?.setFieldValue(
            'whichProductsAbroad',
            data?.whichProductsAbroad || ''
        );
        formik?.setFieldValue(
            'foreignCurrencyAccounts',
            data?.foreignCurrencyAccounts || ''
        );
    }, [data]);

    return {
        formik,
    };
};
